/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentPlatformOption } from './TournamentPlatformOption';
import {
    TournamentPlatformOptionFromJSON,
    TournamentPlatformOptionFromJSONTyped,
    TournamentPlatformOptionToJSON,
    TournamentPlatformOptionToJSONTyped,
} from './TournamentPlatformOption';

/**
 * 
 * @export
 * @interface TournamentPlatformsResponse
 */
export interface TournamentPlatformsResponse {
    /**
     * 
     * @type {Array<TournamentPlatformOption>}
     * @memberof TournamentPlatformsResponse
     */
    platforms?: Array<TournamentPlatformOption>;
}

/**
 * Check if a given object implements the TournamentPlatformsResponse interface.
 */
export function instanceOfTournamentPlatformsResponse(value: object): value is TournamentPlatformsResponse {
    return true;
}

export function TournamentPlatformsResponseFromJSON(json: any): TournamentPlatformsResponse {
    return TournamentPlatformsResponseFromJSONTyped(json, false);
}

export function TournamentPlatformsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPlatformsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'platforms': json['platforms'] == null ? undefined : ((json['platforms'] as Array<any>).map(TournamentPlatformOptionFromJSON)),
    };
}

export function TournamentPlatformsResponseToJSON(json: any): TournamentPlatformsResponse {
    return TournamentPlatformsResponseToJSONTyped(json, false);
}

export function TournamentPlatformsResponseToJSONTyped(value?: TournamentPlatformsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platforms': value['platforms'] == null ? undefined : ((value['platforms'] as Array<any>).map(TournamentPlatformOptionToJSON)),
    };
}

